import { EvaluationContext } from '@openfeature/react-sdk';
import { EvaluationOptions, FeatureFlagContext } from '../types';
import { ReactFlagEvaluationOptions as OpenFeatureFlagEvaluationOptions } from '@openfeature/react-sdk';

export function toEvaluationContext(context: FeatureFlagContext): EvaluationContext {
  return {
    targetingKey: context.userId,
    ...(context.email !== undefined && { email: context.email }),
    ...(context.username !== undefined && { username: context.username }),
  };
}

export function buildProviderOptions(
  options?: EvaluationOptions
): OpenFeatureFlagEvaluationOptions {
  return {
    ...(options?.suspend !== undefined && { suspend: options.suspend }),
    ...(options?.updateOnContextChanged !== undefined && {
      updateOnContextChanged: options.updateOnContextChanged,
    }),
    ...(options?.updateOnConfigurationChanged !== undefined && {
      updateOnConfigurationChanged: options.updateOnConfigurationChanged,
    }),
  };
}
